import { render, staticRenderFns } from "./BoxCalculation.vue?vue&type=template&id=5e2b90fc&"
import script from "./BoxCalculation.vue?vue&type=script&lang=js&"
export * from "./BoxCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports